import React, { useEffect, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import { useNavigate } from "react-router-dom";
import api_requests from "../../resources/api_requests";

const OrderNotAssign = ({ handle_retry }) => {
  const navigate = useNavigate();
  const hanle_home = () => {
    navigate("/dashboard");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-6 z-[10000]">
      <div className="bg-white rounded-xl shadow-3xl max-w-md overflow-x-hidden">
        <div className="relative flex justify-center  ">
          <img src={ImageLinks.ellips_not_assign} className="w-[100%]" />
          <div className="w-12 h-12 flex items-center justify-center rounded-full absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 ">
            <img src={ImageLinks.info_light_yellow} />
          </div>
        </div>
        <div className="p-6 text-center mt-6 flex gap-2 flex-col">
          <p className="font-custom text-xl font-bold text-dark_black">
            Rider Unavailable
          </p>
          <p className="font-custom text-sm font-medium text-dark_black ">
            We’re unable to assign your package to a rider.
          </p>
        </div>
        <div className="flex w-full gap-3 justify-center px-6 mb-8">
          <button
            onClick={hanle_home}
            className="font-custom text-base font-semibold btn w-[50%] text-secondary bg-white rounded-[30px] border-2	border-secondary"
          >
            Home
            {/* Cancel */}
          </button>
          <button
            onClick={handle_retry}
            className="font-custom text-base font-semibold btn w-[50%] bg-primary text-white cursor-not-allowed rounded-[30px]"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderNotAssign;
